<template>
  <div class="flex-page">
    <a-form
      class="form"
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="姓名">{{info.name}}</a-form-item>
      <a-form-item label="Logo">
        <img v-if="info.logo" style="height: 60px" :src="this.API + info.logo" alt="">
      </a-form-item>
      <a-form-item label="照片">
        <img v-if="info.photo" style="height: 100px" :src="this.API + info.photo" alt="">
      </a-form-item>
      </a-form-item>
      <a-form-item label="简介">{{info.desc}}</a-form-item>
      <a-form-item label="城市">{{info.city}}</a-form-item>
      <a-form-item label="地址">{{info.addr}}</a-form-item>
      <a-form-item label="电话">{{info.tel}}</a-form-item>
      <a-form-item label="邮件">{{info.email}}</a-form-item>
      <a-form-item label="其他联系方式">{{info.other_contact}}</a-form-item>
      <a-form-item label="详细介绍">
        <div v-html="info.content"></div>
      </a-form-item>
    </a-form>
    <div class="buttons">
      <a-button type="primary" @click="update">编辑</a-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.form {
  padding: 40px;
}
.sec{
  margin: 15px;
}
img{
  max-width: 100%;
}
</style>

<script>
export default {
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 3,
        },
        wrapperCol: {
          span: 20,
        },
      },
      cateList: [],
      info: {},
    };
  },
  async created () {
    const id = this.$route.query.id;
    const r = await this.$axios.get('/seller/getInfo?id=' + id);
    if(r.status == 1){
      this.info = r.info
    }
  },
  methods: {
    update () {
      this.$router.push(`/seller/update?id=${this.info.id}`)
    }
  },
};
</script>